import { LegalPage } from "@/components/common/LegalPage";
import { privacySections, LEGAL_UPDATED } from "@/data/legal.data";

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      seoTitle="Privacy Policy"
      seoDescription="Read the VibeWell privacy policy — how we collect, use and protect your information."
      path="/privacy"
      updated={LEGAL_UPDATED}
      intro="How VibeWell collects, uses and protects your information."
      sections={privacySections}
    />
  );
}
